import React, { useEffect, useRef, useState } from 'react'
import { Modal, Button, Form, Divider, Tooltip, message, Row, Select, Spin, Collapse, Popover } from 'antd'
import { connect, useSelector } from 'react-redux'
import './index.scss'
import { DocumentsIco, MinusSmallIco, ModalCloseIco, PlusSmallIco, SaveBlueIco, SpinnerIco } from '../../../modules/CustomIcons'
import TableComponent from 'components/Table'
import { LOGIN_PAGE, OWNACCOUNT } from 'constants/constants'
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import asanLogo from 'assets/images/icons/asan-logo.png'
import questionMark from 'assets/images/icons/question.png'
import { QRCodeSVG } from 'qrcode.react'
import '../../pages/Login/components/Sidebar/SIMAEntrance/sima.scss'
import SuccessOrErrorModal from 'components/SuccessOrErrorModal'
import {
  getTransactionButtons,
  RuleTransactionButton,
} from '../../services/Auth/RuleTransactionButton'
import { API_URL, httpVeryfied } from '../../services/config'
import OtpInput from 'react-otp-input'
import Timer from 'components/Timer'
import '../../pages/Login/components/Sidebar/MessageInput/index.scss'
import { getTransactionStatus } from '../../services/Auth/TransactionStatus'
// import {changeStatus} from '../../store/actions/transfers'
import { Scrollbar } from 'smooth-scrollbar-react'
import type { Scrollbar as BaseScrollbar } from 'smooth-scrollbar/scrollbar'
import { useActions } from '../../hooks/useActions'
import { changeStatusHandler } from 'store/actions/transfers'
import { checkAmountForRequest, convertBase64, resetForm } from "../../services/helper";
import { uploadFile } from "../../services/Transfers/Files";
import {
  footerBtnsFirstModal,
  footerBtnsSecondSalary
} from "pages/Transfers/StatusRender";
import SaveAsTemplate from "components/SaveAsTemplate";
import { getAllFilesOrderExcel, getAllFilesOrderPdfByName } from "../../services/transfers";
import { secureLocalStorageGet } from '../../helpers'
import { useTranslation } from 'react-i18next'
import { getMessageLists } from "store/actions/home";
import { getCurrentCompany } from "../../services/user";
import DocumentsPreviewModal from 'components/DocumentsPreviewModal'
import DgkFormModal from "../../components/DGKmodals/dgkForm";
const SIMA_SIGN_DURATION = 300

// Dense decorative value for the blurred placeholder QR shown behind the
// "QR aktivləşdir" button — same string as the login SIMA tab so they match.
const SIMA_QR_PLACEHOLDER = 'https://simaimza.az/placeholder/activate?ref=login&session=00000000-0000-0000-0000-000000000000'

const formatSimaTime = (time: number) => {
  const minutes = Math.floor(time / 60)
  const seconds = time % 60
  return `0${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`
}

const formatRemainingTime = (time: number) => {
  const minutes = Math.floor((time % 1200) / 60)
  const seconds = time % 60

  return `0${minutes}:${seconds == 0 || seconds < 10 ? `0${seconds}` : seconds}`
}

const renderTime = ({ remainingTime }) => {
  if (remainingTime === 0) {
    return <div className="timer"></div>
  }

  return (
    <div className="timer">
      <div className="value">{formatRemainingTime(remainingTime)}</div>
    </div>
  )
}


const NextModal: React.FC<any> = (props: any, messageList) => {
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng")

  const text = (
    <div className="ant-tooltip-inner__data">
      {messageList?.result !== undefined ? (language == "az" ?
         messageList.result.find(text=> text.messageKey === 'INFO.ASAN')?.textAZE : language == "ru" ? messageList.result.find(text=> text.messageKey === 'INFO.ASAN')?.textRU : language == "en" ? messageList.result.find(text=> text.messageKey === 'INFO.ASAN')?.textENG : "") : ""}<br />
    </div>
  )
  let custom_class = props.className || ''
  const [nextModalVisible, setNextModalVisible] = useState(
    props.visible || false
  )
  const [asanModalVisible, setAsanModalVisible] = useState(false)
  const [otpCodeModalVisible, setOtpCodeModalVisible] = useState(false)
  const [showSuccessOrError, setShowSuccessOrError] = useState(false)
  const [showTimeError, setShowTimeError] = useState(false)
  const [transactionButtonsStatus, setTransactionButtonsStatus] = useState<RuleTransactionButton>()
  const [verifyCode, setVerifyCode] = useState<number>()
  const [phoneNumber, setPhoneNumber] = useState<string>()
  const [otpNumberCount, setOtpNumberCount] = useState<number>(6)
  const [otpCode, setOtpCode] = useState<number[]>([])
  const [otpCodeHasError, setOtpCodeHasError] = useState<boolean>(false)
  const modalData = props.data
  const [popupType, setPopupType] = useState("success")
  const [form] = Form.useForm()
  const scrollbar = useRef<BaseScrollbar | null>(null)
  const [minutes, setMinutes] = useState<number>(5)
  const [reset, setReset] = useState<boolean>(false)
  const [modalText, setModalText] = useState<string>(props.nextModalText)
  const [loading, setLoading] = useState<boolean>(false)
  const [loadingSend, setLoadingSend] = useState<boolean>(false)
  const [loadingApprove, setLoadingApprove] = useState<boolean>(false)
  const [errorService, setErrorService] = useState("")
  const [saveAsTemplatePopupVisible, setSaveAsTemplatePopupVisible] = useState<boolean>(false);
  const [openDgkFormModal, setOpenDgkFormModal] = useState<boolean>(false); 
  let channel = secureLocalStorageGet('channel')
  const [smsClicked, setClicked] = useState(true)
  const selectOptions = ['AZ', 'EN', 'RU']
  const { Panel } = Collapse
  const [activePanel, setPanel] = useState(false)
  const [activePanelNotify, setPanelNotify] = useState(false)
  const [multipleButton, setMultipleButton] = useState(false)
  const [footerBtnsSecond, setFooterBtnsSecond] = useState(footerBtnsSecondSalary)
  const [footerBtnsFirst, setFooterBtnsFirst] = useState(footerBtnsFirstModal)
  const dgkData = useSelector((state: any) => state.dgk?.data);
  const [visible, setVisible] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [selectLang, setLanguage] = useState('AZ')
  const [documentsPreviewModalVisible, setDocumentsPreviewModalVisible] = useState(false);
  const [simaModalVisible, setSimaModalVisible] = useState(false)
  const [simaQrCode, setSimaQrCode] = useState<string>('')
  const [simaTimeLeft, setSimaTimeLeft] = useState(SIMA_SIGN_DURATION)
  const [simaExpired, setSimaSignExpired] = useState(false)
  const [simaSignError, setSimaSignError] = useState(false)
  const [simaSignErrorMsg, setSimaSignErrorMsg] = useState('')
  const simaPollingActive = useRef(false)
  // Holds the signing request so the expired-QR "QR aktivləşdir" button can
  // replay it and fetch a fresh QR instead of closing the modal.
  const simaRetryRef = useRef<() => void>(() => {})
  const lastRequestTypeRef = useRef('')
  // console.log("le",dgkData);
  

  const content = (
    <div>
      <p onClick={props.handleGetFileClick} className={'pdf_text'}>{t("transfers.seperatePDF")}</p>
      <p onClick={props.handleGetFileClickMultiple} className={'pdf_text'}>{t("transfers.multiplePDF")}</p>
    </div>
  );

  useEffect(() => {
    setErrorService("")
    setModalText(props.nextModalText)
    setNextModalVisible((old_value) => props.visible)
    if (!props.source) {
      getTransactionButtons().then((res) => {
        setTransactionButtonsStatus((olda_data) => res)
      })
    }

  }, [props.visible])

  useEffect(() => {
    setTimeout(() => {
      if (scrollbar.current && modalData.rubNote)
        scrollbar.current?.scrollTo(undefined, 100000);

    }, 300);
  }, [props.visible, modalData])

  useEffect(() => {
    setTimeout(() => {
      if (scrollbar.current && props.anipay) {
        scrollbar.current?.scrollTo(undefined, 100000);
      }
    }, 300);
  }, [props.visible, props.anipay])

  useEffect(() => {
    setLanguage('AZ')
    setPanel(false)
    setPanelNotify(false)
    let template = false;
    if (props.data !== undefined && props.data['modalTitle'] === t("home.currencyExchange"))
      template = true;
    if (props.btnData !== undefined && props.btnData !== {}) {
      footerBtnsSecond[0]['visible'] = props.btnData['singlePdfButton'];
      footerBtnsSecond[1]['visible'] = props.btnData['excelButton'];
      footerBtnsSecond[2]['visible'] = props.btnData['swiftButton'];
      footerBtnsSecond[3]['visible'] = props.btnData['adocButton'];
      footerBtnsFirst[0]['visible'] = props.btnData['repeatButton'];
      footerBtnsFirst[1]['visible'] = props.btnData['editButton'];
      if (!template)
        footerBtnsFirst[2]['visible'] = props.btnData['saveAsTemplateButton'];
      else
        footerBtnsFirst[2]['visible'] = false;
      footerBtnsFirst[3]['visible'] = props.btnData['deleteButton'];
    } else if (props.batchtransfer) {
      footerBtnsSecond[0]['visible'] = true
      footerBtnsSecond[1]['visible'] = false

    } else {
      footerBtnsSecond[0]['visible'] = false;
      footerBtnsSecond[1]['visible'] = false;
      footerBtnsSecond[2]['visible'] = false;
      footerBtnsFirst[0]['visible'] = false;
      footerBtnsFirst[1]['visible'] = false;
      footerBtnsFirst[2]['visible'] = false;
      footerBtnsFirst[3]['visible'] = false;
    }
    if (props.multiple) {
      setMultipleButton(true);
    }
    else {
      setMultipleButton(false);
    }
  }, [props.selectedType, props.multiple, props.data])

  const onClose = () => {
    props.onClose(false)

    setNextModalVisible(false)
    setAsanModalVisible(false)
    setOtpCodeModalVisible(false)
    setShowSuccessOrError(false)

    /*setTimeout(() => {
      window.location.reload();
    }, 500)*/
  }

  const onCloseModal = () => {
    props.onClose((old_value) => false)

    setNextModalVisible(false)
    setAsanModalVisible(false)
    setOtpCodeModalVisible(false)
    setShowSuccessOrError(false)

    /*setTimeout(() => {
      window.location.reload();
    }, 500)*/
  }

  const onCloseSuccessModal = () => {

    if (props.onCloseSuccessModal !== null && props.onCloseSuccessModal !== undefined) {
      props.onCloseSuccessModal((old_value) => false)
    }

    props.onClose((old_value) => false)
    setNextModalVisible(false)
    setAsanModalVisible(false)
    setOtpCodeModalVisible(false)
    setShowSuccessOrError(false)

    /*setTimeout(() => {
      window.location.reload();
    }, 500)*/
  }

  const showSuccessModal = () => {
    setShowSuccessOrError(old_status => true);
    if (props.currentForm) {
      resetForm(props.currentForm)
    }
  }

  const showAsanModal = () => {
    // setNextModalVisible(false)
    setAsanModalVisible(true)
  }

  const showOtpCodeModal = () => {
    // setNextModalVisible(false)
    setOtpCodeModalVisible(true)
    setClicked(false)
    setOtpCode((old_data) => [])
    setOtpCodeHasError((old_data) => false)
  }

  const hideOtpCodeModal = () => {
    setNextModalVisible(true)
    setOtpCodeModalVisible(false)
  }

  const checkAsanVerifyCode = (code: number) => {
    setPopupType("success")
    return new Promise((resolve, reject) => {
      function checkResponse() {
        httpVeryfied()
          .get(`${API_URL}transaction/status/${code}`)
          .then((response: any) => {
            let data = response.data.data
            if (data?.lastStatus == 'SIGNATURE_CREATED' && response?.data?.status == 'SUCCESS') {
              if (data?.trnDetails !== undefined && data?.trnDetails !== null && data?.trnDetails.length > 0 && data?.trnDetails[0].status === "WARN")
                setModalText(t("notification.sentToBank"))
              else if (data?.trnDetails !== undefined && data?.trnDetails !== null && data?.trnDetails.length > 0 && data?.trnDetails[0].status === "OUTOF")
                setModalText(t("notification.sentToBankAndProcessedNextDay"));
              else if (data?.trnDetails[0].trnStatus === "BANK_SUCCESS") {
                setModalText(t("notification.transferSentToBank"));
              }
              else
                setModalText(t("notification.transferCreatedSigned"));
              setPopupType('success');
              setAsanModalVisible(false)
              showSuccessModal();
            } else if (data?.lastStatus == 'OUTSTANDING_TRANSACTION') {
              window.setTimeout(checkResponse, 1000)
            } else {
              setAsanModalVisible(false)
              setModalText(response.data.message !== null ? response.data.message : "")
              setPopupType("error")
              showSuccessModal();
            }
          }).catch((e) => {
            setAsanModalVisible(false)
            setShowSuccessOrError(true)
            setPopupType("error")
            setModalText(t("notification.errorOccured"))
          })
      }
      checkResponse()
    })
  }

  const checkAsanVerifyCodeTransfers = (code: number) => {
    setPopupType("success")
    return new Promise((resolve, reject) => {
      function checkResponse() {
        httpVeryfied()
          .get(`${API_URL}transaction/status/${code}`)
          .then((response: any) => {
            let data = response.data.data
            if (data.lastStatus == 'SIGNATURE_CREATED' && response.data.status == 'SUCCESS') {
              if (data?.trnDetails !== undefined && data?.trnDetails !== null && data?.trnDetails.length > 0 && data?.trnDetails[0].status === "WARN")
                setModalText(t("notification.sentToBank"))
              else if (data?.trnDetails !== undefined && data?.trnDetails !== null && data?.trnDetails.length > 0 && data?.trnDetails[0].status === "OUTOF")
                setModalText(t("notification.sentToBankAndProcessedNextDay"));
              else if (data?.trnDetails[0].trnStatus === "BANK_SUCCESS") {
                setModalText(t("notification.transferSentToBank"));
              }
              else
                setModalText(t("notification.transferCreatedSigned"));
              setPopupType('success');
              setAsanModalVisible(false)
              showSuccessModal();
            } else if (data.lastStatus == 'OUTSTANDING_TRANSACTION') {
              window.setTimeout(checkResponse, 1000)
            } else {
              setAsanModalVisible(false)
              setModalText(response.data.message !== null ? response.data.message : "")
              setPopupType("error")
              showSuccessModal();
            }
          }).catch((e) => {
            setAsanModalVisible(false)
            setShowSuccessOrError(true)
            setPopupType("error")
            setModalText(t("notification.errorOccured"))
          })
      }
      checkResponse()
    })
  }

  const saveFilesExcel = async (PMTID: string, pdfFiles: any) => {
    let returnValue = false;
    let fileDetailsList = {
      'fileDetailsList': []
    };
    if (pdfFiles && pdfFiles.length > 0) {
      for (let file of pdfFiles) {
        let convert = await convertBase64(file);

        fileDetailsList['fileDetailsList'].push({
          fileBase64: convert,
          pmtid: PMTID,
          fileName: file.name,
          mimeType: "application/vnd.ms-excel"
        })
      }
      const res = await uploadFile(fileDetailsList);
      if (res?.status === "SUCCESS")
        returnValue = true;
    }

    return returnValue

  }

  const saveFiles = async (ibankRef: string, PMTID: string) => {

    let formData = props.data;

    let pdfFiles = formData.pdfFiles;
    let fileDetailsList = {
      'fileDetailsList': []
    };
    if (pdfFiles && pdfFiles.length > 0) {
      for (let file of pdfFiles) {
        let convert = await convertBase64(file.file.originFileObj !== undefined ? file.file.originFileObj : file.file);

        fileDetailsList['fileDetailsList'].push({
          fileBase64: convert,
          pmtid: PMTID,
          fileName: file.file.name,
          mimeType: file.file.type
        })
      }

      uploadFile(fileDetailsList);
    }

  }
  const saveFilesRepeat = async (ibankRef: string, PMTID: string) => {
    let pdfFiles = props.repeatPdfList;
    let fileDetailsList = {
      'fileDetailsList': []
    };
    if (pdfFiles && pdfFiles.length > 0) {
      for (let file of pdfFiles) {


        fileDetailsList['fileDetailsList'].push({
          fileBase64: file.fileBase64,
          pmtid: PMTID,
          fileName: file.fileName,
          mimeType: file.mimeType
        })
      }

      uploadFile(fileDetailsList);
    }

  }
  useEffect(() => {
    simaPollingActive.current = simaModalVisible && !simaExpired
  }, [simaModalVisible, simaExpired])

  // Restart the countdown whenever a fresh QR arrives — the initial request and
  // after "QR aktivləşdir" replays it (which swaps simaQrCode).
  useEffect(() => {
    if (!simaModalVisible || simaExpired || !simaQrCode) return
    setSimaTimeLeft(SIMA_SIGN_DURATION)
    const timer = setInterval(() => {
      setSimaTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer)
          setSimaSignExpired(true)
          return 0
        }
        return prev - 1
      })
    }, 1000)
    return () => clearInterval(timer)
  }, [simaModalVisible, simaQrCode])

  const checkSimaSigningStatus = (code: string) => {
    simaPollingActive.current = true
    setPopupType("success")
    return new Promise((resolve, reject) => {
      function checkResponse() {
        if (!simaPollingActive.current) return
        httpVeryfied()
          .get(`${API_URL}transaction/status/${code}`)
          .then((response: any) => {
            if (!simaPollingActive.current) return
            let data = response.data.data
            if (data?.lastStatus == 'SIGNATURE_CREATED' && response?.data?.status == 'SUCCESS') {
              if (data?.trnDetails?.length > 0 && data.trnDetails[0].status === "WARN")
                setModalText(t("notification.sentToBank"))
              else if (data?.trnDetails?.length > 0 && data.trnDetails[0].status === "OUTOF")
                setModalText(t("notification.sentToBankAndProcessedNextDay"))
              else if (data?.trnDetails?.[0]?.trnStatus === "BANK_SUCCESS")
                setModalText(t("notification.transferSentToBank"))
              else
                setModalText(t("notification.transferCreatedSigned"))
              setPopupType('success')
              setSimaModalVisible(false)
              showSuccessModal()
            } else if (data?.lastStatus == 'OUTSTANDING_TRANSACTION') {
              window.setTimeout(checkResponse, 1000)
            } else {
              setSimaSignErrorMsg(response.data.message || t("notification.errorOccured"))
              setSimaSignError(true)
            }
          }).catch(() => {
            if (!simaPollingActive.current) return
            setSimaSignErrorMsg(t("notification.errorOccured"))
            setSimaSignError(true)
          })
      }
      // 4s initial buffer — user needs time to open SIMA app and scan QR
      window.setTimeout(checkResponse, 4000)
    })
  }

  const sendTransactionRequest = async (RequestType: string, retry: boolean) => {
    lastRequestTypeRef.current = RequestType
    setModalText(props.nextModalText);
    setPopupType('success');
    setErrorService("")
    // setClicked(false)
    if (RequestType === 'SAVE')
      setLoading(true)
    else
      setLoadingApprove(true)
    let response = true;

    props.callBackApi(RequestType, retry, props.fileListSalary)?.then((res: any) => {
      setLoading(false)
      setLoadingApprove(false)
      if (res?.status === "SUCCESS" || res?.resultMessage === "SUCCESS") {

        saveFilesRepeat(res.data?.ibankRef, res.data?.PMTID)
        saveFiles(res.data?.ibankRef, res.data?.PMTID);
        if (props.fileListSalary !== undefined && props.fileListSalary !== [])
          saveFilesExcel(res.data?.PMTID, props.fileListSalary)
        if (RequestType === 'SAVE') {
          onClose();
          setModalText(t("notification.transferCreated"));
          setPopupType('success');
          showSuccessModal();
        } else if (RequestType === 'APPROVE') {
          if (props.transferSP) {
            if (res?.fileDescriptors !== undefined && res?.fileDescriptors !== null && res?.fileDescriptors.length > 0 && res?.fileDescriptors[0]?.status === "WARN")
              setModalText(t("notification.sentToBank"))
            else if (res?.fileDescriptors !== undefined && res?.fileDescriptors !== null && res?.fileDescriptors.length > 0 && res?.fileDescriptors[0]?.status === "OUTOF")
              setModalText(t("notification.sentToBankAndProcessedNextDay"));
            else
              setModalText(t("notification.transferConfirmed"));
          }
          else {
            if (res?.fileDescriptors !== undefined && res?.fileDescriptors !== null && res?.fileDescriptors.length > 0 && res?.fileDescriptors[0]?.trnStatus === "BANK_SUCCESS") {
              setModalText(t("notification.transferSentToBank"));
            } else
              setModalText(t("notification.transferCreatedConfirmed"));
          }
          setPopupType('success');
          // setNextModalVisible(false)
          showSuccessModal();
        }
        else {
          let channel = secureLocalStorageGet('channel')
          if (channel === 'TOTP' || channel === 'OTP') {
            // let phone_number = localStorage.getItem('phoneNumber');
            let phone_number = secureLocalStorageGet('phoneNumber')
            if (phone_number === undefined || phone_number === "" || phone_number === null)
              phone_number = res?.data?.phoneNumber
            if (phone_number !== undefined && phone_number !== "" && phone_number !== null) {
              let last_4_number = phone_number.slice(-4)
              let make_phone_number =
                last_4_number[0] +
                last_4_number[1] +
                '-' +
                last_4_number.slice(-2)
              setPhoneNumber((old_data) => make_phone_number)
            }
            setOtpNumberCount((old_number) => (channel === 'TOTP' ? 6 : 5))

            showOtpCodeModal()
          } else if (channel === 'SIMA') {
            const qrCode = res?.data?.qrCode || ''
            const txCode = res?.data?.verification
             console.log("res2",res);
            simaRetryRef.current = () => sendTransactionRequest(RequestType, false)
            setSimaQrCode(qrCode)
            setSimaSignExpired(false)
            setSimaSignError(false)
            setSimaSignErrorMsg('')
            setSimaModalVisible(true)
            checkSimaSigningStatus(txCode)
          } else {
            let verify_code = res.data.verification
            setVerifyCode((old_code) => verify_code)
            checkAsanVerifyCode(verify_code)
            showAsanModal()
          }
        }
      } else {
        setLoading(false)
        setLoadingApprove(false)
        if (res?.resultCode !== "500") {
          setErrorService((res?.detail !== undefined ? res?.detail : '' + ' ') + (res?.message !== undefined ? res?.message : '' + ' ') + (res?.resultMessage !== undefined ? res?.resultMessage : ''));
        } else {

          setNextModalVisible(false)
          setShowSuccessOrError(true)
          if (props.anipay) {
            setModalText(res?.message)
          } else {
            setModalText(t("notification.errorOccuredWhenSendToBank"));

          }
          setPopupType('error');
        }
      }
    }).catch((e: any) => {
      setLoading(false)
      setLoadingApprove(false)
      setErrorService(e?.data?.detail)
    })
  }

  const sendTransactionApprove = async (RequestType: any, retry: boolean) => {
    setModalText(props.nextModalText);
    setPopupType('success');
    setErrorService("");
    setLoadingApprove(true)
    let response = true;

    props.callBackApi(RequestType, retry, props.fileListSalary).then((res) => {

      // saveFilesExcel(res.data?.ibankRef, res.data?.PMTID, props.fileListSalary)
      if (props.fileListSalary !== undefined)
        saveFilesExcel(res.data?.PMTID, props.fileListSalary)
      setLoadingApprove(false)
      if (res?.status === "SUCCESS" || res?.resultMessage === "SUCCESS") {
        if (RequestType === 'APPROVE') {
          if (props.transferSP) {
            if (res?.fileDescriptors !== undefined && res?.fileDescriptors !== null && res?.fileDescriptors.length > 0 && res?.fileDescriptors[0]?.status === "WARN")
              setModalText(t("notification.sentToBank"))
            else if (res?.fileDescriptors !== undefined && res?.fileDescriptors !== null && res?.fileDescriptors.length > 0 && res?.fileDescriptors[0]?.status === "OUTOF")
              setModalText(t("notification.sentToBankAndProcessedNextDay"));
            else
              setModalText(t("notification.transferConfirmed"));
          }
          else
            setModalText(t("notification.transferCreatedConfirmed"));
          setPopupType('success');
          setNextModalVisible(false)
          showSuccessModal();
        } else {
          let channel = secureLocalStorageGet('channel')
          if (channel === 'TOTP' || channel === 'OTP') {
            // let phone_number = localStorage.getItem('phoneNumber');
            let phone_number = secureLocalStorageGet('phoneNumber');
            let last_4_number = phone_number.slice(-4)
            let make_phone_number =
              last_4_number[0] + last_4_number[1] + '-' + last_4_number.slice(-2)
            setPhoneNumber((old_data) => make_phone_number)
            setOtpNumberCount((old_number) => (channel === 'TOTP' ? 6 : 5))
            showOtpCodeModal()
          } else if (channel === 'SIMA') {
            const qrCode = res?.data?.qrCode || ''
            const txCode = res?.data?.verification
            console.log("res1",res);
            simaRetryRef.current = () => sendTransactionApprove(RequestType, false)
            setSimaQrCode(qrCode)
            setSimaSignExpired(false)
            setSimaModalVisible(true)
            checkSimaSigningStatus(txCode)
          } else {
            setVerifyCode((old_code) => res.verfication)
            showAsanModal()
            checkAsanVerifyCodeTransfers(res.verfication)
          }
        }
      } else {
        if (res?.resultCode !== "500") {
          setErrorService((res?.detail !== undefined ? res?.detail : '' + ' ') + (res?.message !== undefined ? res?.message : '' + ' ') + (res?.resultMessage !== undefined ? res?.resultMessage : ''));
        } else {

          setNextModalVisible(false)
          setShowSuccessOrError(true)
          setModalText(t("notification.errorOccuredWhenSendToBank"));
          setPopupType('error');
        }
      }
    }).catch((e) => {
      setLoading(false)
      setLoadingApprove(false)
      setErrorService(e?.data?.detail)
    })
    setLoadingApprove(false)
  }

  const handleTransactionReq = async () => {
    if (props.btnType) {
      await sendTransactionApprove(props.requestType, false)
    } else {
      await sendTransactionRequest('SIGN', false)
    }
  }

  const handleValue = (value: any) => {
    setOtpCode(value)
  }

  const checkOTPCode = () => {
    setModalText(props.nextModalText);
    setLoadingSend(true)
    setPopupType('success');
    if (otpCode.length == 5 || otpCode.length == 6) {
      getTransactionStatus(otpCode).then((res) => {
        if (res.status === 'ERROR' && res.code === 3) {
          setOtpCodeHasError((old_data) => true)
          setLoadingSend(false)

        } else if (res.status === 'ERROR' && res.code === 5) {
          setOtpCodeHasError((old_data) => true)
          setLoadingSend(false)


        } else if (res.status === 'ERROR' && res.code === 500) {
          setLoadingSend(false)

          if (res?.data?.trnDetails[0].status === "LIMIT") {
            setModalText(res?.data?.trnDetails[0].message)
            setPopupType('error');
            showSuccessModal();
            
          } else {
            setOtpCodeHasError((old_data) => false)
            setOtpCodeModalVisible(false)
            setModalText(t("notification.errorOccuredWhenSendToBank"));
            setPopupType('error');
            showSuccessModal();
          }
        }
        else {
          setLoadingSend(false)

          if (props.modalType === undefined || props.modalType === null) {
            if (res?.data?.trnDetails[0].status === "WARN")
              setModalText(t("notification.sentToBank"))
            else if (res?.data?.trnDetails[0].status === "OUTOF")
              setModalText(t("notification.sentToBankAndProcessedNextDay"));
            else if (res?.data?.trnDetails[0].trnStatus === "BANK_SUCCESS") {
              setModalText(t("notification.transferSentToBank"));
              setPopupType('success');
            }
            else
              setModalText(t("notification.transferCreatedSigned"));
            setPopupType('success');
            setOtpCodeHasError(() => false)
            setOtpCodeModalVisible(false)
    setLoading(false)
    showSuccessModal();
          } else {
            if (res?.data?.trnDetails[0].status !== "" && res?.data?.trnDetails[0].status !== undefined && res?.data?.trnDetails[0].status !== null)
              setModalText(t("notification.sentToBank"))
            if (res?.data?.trnDetails[0].trnStatus === "BANK_ERROR")
              if (res?.data?.trnDetails[0].status === "LIMIT") {
                setModalText(res?.data?.trnDetails[0].message)
                setPopupType('error');
              } else {
                setModalText(t("notification.errorOccuredWhenSendToBank"));
              }
            else if (res?.data?.trnDetails[0].trnStatus !== "BANK_SUCCESS") {
              if (res?.data?.userRole === "SIGNER")
                setModalText(t("notification.transferSigned"));
              else
                setModalText(t("notification.transferConfirmed"));
              setPopupType('success');
            } else if (props.selectedType === "BANK_ERROR") {
              setModalText(t("notification.transferSentToBank"));
              setPopupType('success');
            }
            setOtpCodeHasError((old_data) => false)
            setOtpCodeModalVisible(false)
            showSuccessModal();
            setLoadingSend(false)

          }
          // props.onStatusChange(true)
        }
      }).catch((e) => {
        setOtpCodeModalVisible(false)
        setShowSuccessOrError(true)
        setLoadingSend(false)
        setPopupType("error")
        setModalText(t("notification.errorOccured"))
      })
    }
   

  }

  const resetFormTimer = () => {
    setOtpCodeModalVisible(false)
    setShowTimeError(true)
    // inputRef.current.__clearvalues__()
  }

  const reSend = () => {
    if (smsClicked) {
      setClicked(false)
      sendTransactionRequest('SIGN', true);
    }
    // setMinutes(5);
    // setReset(true);
    // setTimeout(() => setReset(false), 1000);
  }

  // "QR aktivləşdir" (shown only after the QR expires): replay the original
  // signing request to fetch a fresh QR instead of closing the modal.
  const retrySimaSign = () => {
    simaPollingActive.current = false
    setSimaQrCode('')
    setSimaSignExpired(false)
    setSimaSignError(false)
    setSimaSignErrorMsg('')
    setSimaTimeLeft(SIMA_SIGN_DURATION)
    simaRetryRef.current()
  }

  const downloadPDF = async (file: any) => {
    let fileBase64 = await convertBase64(file.file.originFileObj !== undefined ? file.file.originFileObj : file.file);
    const fileName = file.label;
    const linkSource = `${fileBase64}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  const handleSave = () => {
    setSaveAsTemplatePopupVisible(old_data => true)
  }

  useEffect(
    () => {
      if (!smsClicked) {
        let timer1 = setInterval(() => setClicked(true), 20 * 1000);
        return () => {
          clearInterval(timer1);
        }
      }
    },
    [smsClicked]
  );

  const handleGetExcelAdditional = async () => {
    setLoadingExcel(true)
    try {
      const data = await getAllFilesOrderExcel(props.openedIbanRef, selectLang)
      data?.data.fileDetailsList.map(function (item, i) {
        const linkSource = `data:${item.mimeType};base64,${item.fileBase64}`
        const downloadLink = document.createElement('a')
        downloadLink.href = linkSource
        downloadLink.download = item.fileName
        downloadLink.click()
      })
    } catch (e) { }
    setLoadingExcel(false)
  }

  const signErrorIcon = lastRequestTypeRef.current === 'SIGN' ? props.errorIcon : undefined
  const dgkTotalPage =
  dgkData?.type === "YGB" || dgkData?.type === "AKT"
    ? dgkData?.pages?.length || 0
    : dgkData?.type === "Avans" || dgkData?.type === "AVANS"
    ? dgkData?.contracts?.length || 0
    : 0;
  // @ts-ignore
  const modalFooter = () => {

    return (
      <>
        {modalData.note && !props.anipay && (
          <div className="flex tab_info_box ">
            <span
              className="passive_text_box passive_text_box_rel"
              dangerouslySetInnerHTML={{ __html: modalData.note }}
            />
          </div>
        )}

        {modalData.alertText && !props.anipay && (
          <div className="flex tab_info_box tab_alert_box">
            <span
              className="passive_text_box passive_text_box_rel"
              dangerouslySetInnerHTML={{ __html: modalData.alertText }}
            />
          </div>
        )}

        {errorService && !props.anipay && (
          <div className="flex tab_info_box tab_alert_box">
            <span
              className="passive_text_box passive_text_box_rel"
              dangerouslySetInnerHTML={{ __html: errorService }}
            />
          </div>
        )}



        {props.transferSP ?
          <div className={'flex flex_wrap modalTransferSpaceBetween'}>
            <div className="transfers-footer_btns1 transfers-footer_btns--modal flex" style={{ position: 'relative', bottom: 12 }}>
              {!multipleButton && <ul className="flex">
                <li>
                  <div className="pagination-selector language-selector"
                    style={{ left: '0px', margin: '0px 20px auto 0px' }}
                  >
                    <Select
                      // open={true}
                      defaultValue={'AZ'}
                      placeholder="AZ"
                      // width={64}
                      onChange={(value: any) => setLanguage(value)}
                    >
                      {selectOptions.map((item) => {
                        return <option value={item}>{item}</option>
                      })}
                    </Select>
                  </div>
                </li>
                {footerBtnsSecond.map((item) => {
                  return (
                    item.visible &&
                    <li>
                      <Tooltip className="footer-tooltip" title={item.title}>
                        {item.key == 'pdf' ?
                          props.loadingPdf ?
                            <div className='ant-btn exportLoadingdiv'><Spin indicator={<SpinnerIco />} /></div>
                            :
                            props.multiple ?
                              <Popover
                                // className = "btn-popover"
                                placement="top"
                                content={content}
                                trigger="click"
                                visible={visible}
                                onVisibleChange={() => setVisible(!visible)}
                              >
                                <Button
                                  icon={item.icon}
                                  disabled={!item.visible || loadingApprove}
                                />
                              </Popover> :
                              <Button
                                icon={item.icon}
                                disabled={!item.visible || loadingApprove}
                                onClick={() =>
                                  props.handleGetFileClick(selectLang)
                                }
                              /> :
                          loadingExcel ?
                            <div className='ant-btn exportLoadingdiv'><Spin indicator={<SpinnerIco />} /></div>
                            :
                            <Button
                              icon={item.icon}
                              disabled={!item.visible || loadingApprove || item.key == 'swift'}
                              onClick={
                                item.key == 'adoc'
                                  ? props.handleGetAdocFileClick
                                  : handleGetExcelAdditional
                              }
                            />
                        }

                      </Tooltip>
                    </li>
                  )
                })}
              </ul>
              }
              {!multipleButton && <ul
                className="flex"
                style={{ marginRight: '86px' }}
              >
                {footerBtnsFirst.map((item) => {
                  return (
                    item.visible && <li>
                      <Tooltip className="footer-tooltip" title={item.title}>
                        <Button
                          ghost
                          icon={item.icon}
                          disabled={!item.visible || loadingApprove}
                          onClick={
                            item.type === 'repeat'
                              ? props.handleRepeat
                              : item.type === 'edit'
                                ? props.handleEdit
                                : item.type === 'save'
                                  ? handleSave
                                  : props.handleDelete
                          }
                        />

                      </Tooltip>
                    </li>
                  )
                })}
              </ul>
              }
            </div>

            <div className={"flex"}>
              {props.requestType === 'SIGN' && props.selectedType !== "BANK_ERROR" ? (
                <div className={"modalButtonDivSignTransfer"}>
                  {
                    loadingApprove ?
                      <div className='ant-btn   exportLoadingdiv transfer_loading' ><Spin indicator={<SpinnerIco />} />
                      </div>
                      :
                      !props.disabledSign && <Button
                        style={{ marginTop: 20 }}
                        size={'large'}
                        htmlType="submit"
                        className="blue-button next_btn btn flex align_center justify_center blue-buttonnext"
                        disabled={props.disabledSign}
                        onClick={handleTransactionReq}
                      >
                        {t("transfers.sign")}
                      </Button>
                  }
                </div>
              ) : (props.selectedType !== "BANK_ERROR" &&
                <div className={"modalButtonDivApproveTransfer"}>
                  {
                    loadingApprove ?
                      <div className='ant-btn exportLoadingdiv transfer_loading'><Spin indicator={<SpinnerIco />} />
                      </div>
                      :
                      <Button
                        size={'large'}
                        htmlType="submit"
                        className="blue-button next_btn btn flex align_center justify_center"
                        disabled={props.selectedType === "DELETED" || props.disabledSign}
                        onClick={() => {
                          sendTransactionRequest(props.btnType || 'APPROVE')
                        }}
                      >
                        {t("login.confirm")}
                      </Button>
                  }
                </div>
              )}
              {
                props.selectedType === "BANK_ERROR" &&
                <div className={"modalButtonDivApproveTransfer"}>
                  {
                    loadingApprove ?
                      <div className='ant-btn exportLoadingdiv transfer_loading'><Spin indicator={<SpinnerIco />} />
                      </div>
                      :
                      <Button
                        size={'large'}
                        htmlType="submit"
                        className="blue-button next_btn btn flex align_center justify_center "
                        onClick={() => {
                          sendTransactionRequest("SEND_BANK")
                        }}
                      >
                        {t("transfers.sendToBank")}
                      </Button>
                  }
                </div>
              }
              <Button
                size={'large'}
                htmlType="submit"
                className="light-button refresh_btn next_modal_cancel_btn btn flex align_center justify_center "
                onClick={onClose}
                disabled={loadingApprove}
              >
                {t("common.close")}
              </Button>
            </div>
          </div>
          : (props.batchtransfer ?
            <div className={'flex flex_wrap modalTransferSpaceBetween'}>
              <div>
                <div className="transfers-footer_btns1 transfers-footer_btns--modal flex" style={{ position: 'relative', bottom: 12 }}>
                  {!multipleButton && <ul className="flex">
                    <li>
                      <div className="pagination-selector language-selector"
                        style={{ left: '0px', margin: '0px 20px auto 0px' }}
                      >
                        <Select
                          // open={true}
                          defaultValue={'AZ'}
                          placeholder="AZ"
                          // width={64}
                          onChange={(value: any) => setLanguage(value)}
                        >
                          {/*{console.log(selectLang)}*/}
                          {selectOptions.map((item) => {
                            return <option value={item}>{item}</option>
                          })}
                        </Select>
                      </div>
                    </li>

                    {footerBtnsSecond.map((item) => {
                      console.log(item)
                      return (
                        item.visible &&
                        <li style={{ display: "flex" }}>
                          <Tooltip className="footer-tooltip" title={item.title}>
                            {item.key == 'pdf' ?
                              props.loadingPdf ?
                                <div className='ant-btn exportLoadingdiv'><Spin indicator={<SpinnerIco />} /></div>
                                :
                                props.multiple ?
                                  <Popover
                                    // className = "btn-popover"
                                    placement="top"
                                    content={content}
                                    trigger="click"
                                    visible={visible}
                                    onVisibleChange={() => setVisible(!visible)}
                                  >
                                    <Button
                                      icon={item.icon}
                                      disabled={!item.visible || loadingApprove}
                                    />
                                  </Popover> :
                                  <>
                                    <Button
                                      icon={item.icon}
                                      disabled={!item.visible || loadingApprove}
                                      onClick={() =>
                                        props.handleGetFileClick(selectLang)
                                      }
                                    />
                                    {/*{ console.log(props.tableData.ibankRef)*/}


                                  </>

                              :
                              <Button
                                icon={item.icon}
                                disabled={!item.visible || loadingApprove || item.key == 'swift'}
                                onClick={
                                  item.key == 'adoc'
                                    ? props.handleGetAdocFileClick
                                    : props.handleOtherClick
                                }
                              />
                            }

                          </Tooltip>

                        </li>
                      )
                    })}

                  </ul>
                  }

                </div>
              </div>

              <div className={"flex"}>


                <Button
                  size={'large'}
                  htmlType="submit"
                  className="light-button refresh_btn next_modal_cancel_btn btn flex align_center justify_center "
                  onClick={onClose}
                  disabled={loadingApprove}
                >
                  {t("common.close")}
                </Button>
              </div>
            </div>
            :
            <div className={'flex' + props.source ? props.className : ''}>

              <DocumentsPreviewModal
                visible={documentsPreviewModalVisible}
                title={t("modal.modalTitleDocs")}

                children={<h1>documents modal</h1>}
                // onBack={() => }
                data={props.currencyModalData}
                onCancel={() => {
                  setDocumentsPreviewModalVisible(false);
                }}
                className='documents_modal'
              />
               
                
              <div className={'flex flex_wrap align_center justify_between '}>
               
                <div style={{
                  display:"flex",
                  gap:"16px",
                  alignItems:"center",
                  justifyContent:"center"
                }}><div style={{position: 'relative', bottom: 20}}>
                 { props.currencyModalData && <Button
                    size={'large'}
                    icon={<DocumentsIco className='' />}
                    className="documents-btn light-button  refresh_btn btn flex align_center justify_center"
                    onClick={(e) => {
                      
                      setDocumentsPreviewModalVisible(true);
                      // setDocumentsModalVisible(true);
                    }}
                  >
                    <p className='documents-btn-text'>{t(OWNACCOUNT.DOCUMENTS)+" "} 
                      (<span className='active' style={{ color: '#1890ff' }}>{+props.currencyModalData?.length}</span>)
                    </p>
                  </Button>}
                </div>
                <div style={{position: 'relative', bottom: 20}}>
                 { dgkData && <Button
                    size={'large'}
                    className="documents-btn light-button  refresh_btn btn flex align_center justify_center"
                    onClick={(e) => {
                      setOpenDgkFormModal(true);
                      // setDocumentsModalVisible(true);
                    }}
                    style={{
                      width:"125px"
                    }}
                  >
                    <p className='documents-btn-text'>
                        {dgkData?.type + " "}
                        (<span className='active' style={{ color: '#1890ff' }}>{dgkTotalPage}</span>)
                      </p>
                  </Button>}
                </div></div>
                <div className={'flex flex_wrap align_center justify_end '}>
                  {modalData.buttons &&
                    Array.isArray(modalData.buttons) &&
                    modalData.buttons.map((btn) => {
                      let btn_item = <></>

                      if (btn.patternButton) {
                        btn_item = (
                          <Button
                            size={'large'}
                            icon={<SaveBlueIco />}
                            className="light-button btn save_btn flex align_center justify_center refresh_btn next_modal_cancel_btn"
                            htmlType="submit"
                            disabled={loading || loadingApprove}
                            onClick={onCloseModal}
                          >
                            {t("newTransfer.saveAsTemplate")}
                          </Button>
                        )
                      }
                      else if (btn.sign && transactionButtonsStatus?.sign) {
                        //sign
                        btn_item = (
                          <div className={"modalButtonDivSign"}>
                            {
                              loadingApprove ?
                                <div className='ant-btn  exportLoadingdiv transfer_loading' style={{ marginBottom: 35 }}><Spin
                                  indicator={<SpinnerIco />} />
                                </div>
                                :
                                <Button
                                  size={'large'}
                                  htmlType="submit"
                                  className="blue-button next_btn btn flex align_center justify_center blue-buttonnext"
                                  disabled={modalData.alertText !== undefined && modalData.alertText !== '' || loading || props.disabled}
                                  onClick={handleTransactionReq}
                                >
                                  {t("transfers.sign")}
                                </Button>
                            }
                          </div>
                        )
                      }
                      else if (btn.approve && transactionButtonsStatus?.approve) {
                        //approve
                        btn_item = (
                          <div className={"modalButtonDivApprove"}>
                            {
                              loadingApprove ?
                                <div className='ant-btn exportLoadingdiv transfer_loading' style={{ bottom: 20 }}><Spin indicator={<SpinnerIco />} />
                                </div>
                                :
                                <Button
                                  size={'large'}
                                  htmlType="submit"
                                  className="blue-button next_btn btn flex align_center justify_center blue-buttonnext"
                                  disabled={modalData.alertText !== undefined && modalData.alertText !== '' || loading}
                                  onClick={() => {
                                    sendTransactionRequest(props.btnType || 'APPROVE', false)
                                  }}
                                >
                                  {t("transfers.approve")}
                                </Button>
                            }
                          </div>
                        )
                      }
                      else if (btn.save && transactionButtonsStatus?.save && !props.btnType) {
                        //save
                        btn_item = (
                          <div>
                            {loading ?
                              <div className='ant-btn exportLoadingdiv transfer_loading' style={{ bottom: 20 }}><Spin indicator={<SpinnerIco />} />
                              </div>
                              : <Button
                                size={'large'}
                                htmlType="submit"
                                className="blue-button next_btn btn flex align_center justify_center blue-buttonnext"
                                disabled={modalData.alertText !== undefined && modalData.alertText !== '' || loadingApprove || props.disabled}
                                onClick={() => {
                                  sendTransactionRequest(props.btnType || 'SAVE', false)
                                }}
                              >
                                {/*{console.log('bura ishledi')}*/}
                                {props.editTransfer ? t("transfers.save") : t("newTransfer.create")}
                              </Button>
                            }
                          </div>
                        )
                      }
                      else if (btn.send && transactionButtonsStatus?.send) {
                        //send
                        /*btn_item=<Button
                            size={'large'}
                            className="light-button refresh_btn next_modal_cancel_btn btn flex align_center justify_center blue-buttonnext"
                            onClick={() => { sendTransactionRequest("SIGN_AND_SEND_BANK") } }
                        >
                          İmzala və Banka göndər
                        </Button>;*/
                      }
                      else if (btn.selectAccount) {
                        //sign
                        btn_item = (
                          <Button
                            size={'large'}
                            htmlType="submit"
                            className="blue-button next_btn btn flex align_center justify_center blue-buttonnext"
                          // onClick={handleTransactionReq}
                          >
                            {t("home.chooseAccounts")}
                          </Button>
                        )
                      }

                      return btn_item
                    })}
                  <div className={"modalButtonDiv1"}>
                    <Button
                      size={'large'}
                      htmlType="submit"
                      className="light-button refresh_btn next_modal_cancel_btn btn flex align_center justify_center blue-buttonnext"
                      disabled={loading || loadingApprove}
                      onClick={onCloseModal}
                    >
                      {
                        props.source ? t("common.close") : t("settings.deactivate")
                      }
                    </Button>
                  </div>
                </div>
              </div>

            </div>
          )
        }
      </>
    )
  }



  const { changeStatusHandler } = useActions()

  const onClosePanel = () => {
    setPanel(!activePanel)
  }

  const onClosePanelNotify = () => {
    setPanelNotify(!activePanelNotify)
  }

  return (
    <>
      {nextModalVisible && (
        <Modal
          title={modalData.modalTitle}
          closeIcon={<ModalCloseIco />}
          centered
          width={props.width || 700}
          visible={nextModalVisible}
          onOk={onCloseModal}
          onCancel={onCloseModal}
          className={`manage_faster_menus swift_modal form_next_modal ${props?.className}`}
          keyboard={false}
          focusTriggerAfterClose={false}
          footer={modalFooter()}
        >
          <Scrollbar
            ref={scrollbar}
            plugins={{
              disableScroll: { direction: 'x' },
            }}
            alwaysShowTracks={true}
          >
            <Form layout="vertical" onFinish={(e) => { }} autoComplete="off">
              {/* groups */}
              {modalData.groups?.map((row) => {
                let table_class = ''

                if (row?.tableHasBorderBottom) {
                  table_class += ' has_border_bottom '
                }

                if (row?.tableHasBorderBottom2) {
                  table_class += ' has_border_bottom has_border_bottom2 '
                }

                if (row?.tableHasBordertop) {
                  table_class += ' has_border_top has_border_top2 '
                }

                if (row?.tableHasMarginBottom) {
                  table_class += ' has_margin_bottom '
                }

                return (
                  <table
                    className={`table table-hover swift_table form_next_table ${table_class}`}
                  >
                    <tbody>
                      {row.title && (
                        <tr>
                          <td
                            className={'table_title'}
                            align={'center'}
                            colSpan={2}
                          >
                            {
                              row.currency ? <div className='currency-title'><span>{row.currency}</span><span>{t("accounts.bankAccountDetails")}</span></div> : <></>
                            }
                            <Divider
                              plain
                              orientation="center"
                              className={'tab_divider_center'}
                            >
                              {row.title}
                            </Divider>
                          </td>
                        </tr>
                      )}

                      {row.title === '' && (
                        <tr>
                          <td
                            className={'table_title'}
                            align={'center'}
                            colSpan={2}
                          >
                            <Divider
                              plain
                              orientation="center"
                              className={'tab_divider_only'}
                            >
                              {row.title}
                            </Divider>
                          </td>
                        </tr>
                      )}

                      {row.tableHasDivider && (
                        <tr>
                          <td
                            className={'table_title'}
                            align={'center'}
                            colSpan={2}
                          >
                            <Divider
                              orientation="center"
                              className={'tab_divider_only'}
                            />
                          </td>
                        </tr>
                      )}

                      {row.data?.map((line) => {
                        // console.log("line",props);
                        
                        return (
                          line !== undefined ?
                            <tr className={line?.rowClass}>
                              <div>
                                <td>{line?.label}</td>
                                <td>{line?.value}</td>
                              </div>
                              {props.currAmount && Object.keys(props.infoForCurrency).length > 0 && line?.label === t("home.commission") ? (<div className={'flex'} style={{
                                width:"100%",
                                display:"flex",
                                alignItems:"center",
                                justifyContent:"center",
                                margin:"1rem",
                              }}>
                                  <div
                                  style={{
                                    backgroundColor: "#E4F1FF",
                                    borderRadius: "12px",
                                    fontWeight: 500,
                                    color:"#5895E2",
                                    border:"1px solid #9EC3F0",
                                    padding:"12px 15px",
                                    width:"570px",
                                    marginRight:"1rem",
                                    textAlign:"center"
                                  }}
                                >
                                      {checkAmountForRequest(props.currAmount)} {props.infoForCurrency?.pmtCurr} = {checkAmountForRequest(props.infoForCurrency?.exchAmount)}{" "}
                                      {props.infoForCurrency?.accCurr} &nbsp;
                                      (1 {props.infoForCurrency?.accCurr} = {props.infoForCurrency?.rate} {props.infoForCurrency?.pmtCurr}) <br />
                                      {t('transfers.swiftCrossMessage')}
                                </div>
                              </div>):null}
                            </tr> : <></>
                        )
                      })}
                    </tbody>
                  </table>
                )
              })}

              {/* edv section */}
              {
                modalData.edvInfoData !== null && modalData.edvInfoData !== undefined ? (
                  <div className={'box_row'}>
                    <div className={'flex direction_column edv_title_box'}>
                      <h3>{modalData.edvInfoData.title}</h3>
                      <p>{modalData.edvInfoData.description}</p>
                    </div>

                    <table
                      className={`table table-hover swift_table form_next_table form_next_table_transparent_row`}
                    >
                      <tbody>
                        {modalData.edvInfoData.data?.map((line) => {
                          return (
                            <tr>
                              <td>{line?.label}</td>
                              <td>{line?.value}</td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                ) : <></>
              }



              {(props.repeatPdfList?.length > 0 || modalData?.pdfFiles?.length > 0) && (

                // <div className={'pdf-div'}>
                <table
                  className={
                    'table swift_table table_pdf modal_pdf line1140'
                  }
                >


                  <tbody>
                    <tr>
                      {props?.repeatPdfList?.length > 0 && <td>{t("transfers.atachedPDF")}</td>}
                      {props?.repeatPdfList?.length > 0 && (
                        <td >
                          {props.repeatPdfList?.map((line: any) => {

                            return (line?.mimeType === "application/pdf" ? <div style={{ paddingBottom: '8px', borderBottom: '1px solid #e4e1e1' }}>
                              <a type={'button'} onClick={() => props.handleGetPdfAdditional(props.tableData?.ibankRef, line?.fileName)} >
                                <p style={{ marginRight: 10 }}>{line?.fileName}</p>
                              </a>
                            </div> : <></>)
                          })}
                        </td>
                      )}

                    </tr>
                    <tr>
                      {props.repeatPdfList?.length > 0 ? <td></td> : <td>{t("transfers.atachedPDF")}</td>}

                      {modalData?.pdfFiles?.length > 0 &&
                        (
                          <td style={{ paddingTop: '5px' }}>

                            {modalData?.pdfFiles?.map((line: any) => {
                              return <div style={{ paddingTop: '0px' }}>
                                <a type={'button'} onClick={() => downloadPDF(line)} >
                                  <p style={{ marginRight: 10 }}>{line?.label}</p>
                                </a>
                              </div>
                            })}
                          </td>
                        )
                      }
                    </tr>
                  </tbody>
                </table>
                // </div>
              )}

              {/*{modalData?.pdfFiles?.length > 0 && (*/}
              {/*  // <div className={'pdf-div'}>*/}
              {/*  <table*/}
              {/*    className={*/}
              {/*      'table swift_table salary-table table_pdf modal_pdf'*/}
              {/*    }*/}
              {/*  >*/}
              {/*    <tbody>*/}
              {/*      <tr>*/}
              {/*        {!props.tableData?.PDF_LIST?.length > 0 && (<td>{t("transfers.atachedPDF")}</td>)}*/}

              {/*        <td>*/}
              {/*          {modalData?.pdfFiles?.map((line: any) => {*/}
              {/*            return <div>*/}
              {/*              <a type={'button'} onClick={() => downloadPDF(line)} >*/}
              {/*                <p style={{ marginRight: 10 }}>{line.label}</p>*/}
              {/*              </a>*/}
              {/*            </div>*/}
              {/*          })}*/}
              {/*        </td>*/}
              {/*      </tr>*/}
              {/*    </tbody>*/}
              {/*  </table>*/}
              {/*  // </div>*/}
              {/*)}*/}

            </Form>
            {modalData.rubNote && (
              <div id={'info'} style={{ maxWidth: "fit-content", flexDirection: "column", textAlign: "left", padding: '50px' }} className="flex tab_info_box ">

                <span
                  style={{ flexDirection: "column" }}
                  className="passive_text_box passive_text_box_rel"
                  dangerouslySetInnerHTML={{ __html: modalData.rubNote }}
                />
              </div>
            )

            }
            {
              props.currency && (
                <div id={'info'} style={{ maxWidth: "fit-content", flexDirection: "column", textAlign: "left", padding: '0 64px',marginTop:55 }} className="flex tab_info_box ">

                <span
                  style={{ flexDirection: "column",}}
                  className="passive_text_box passive_text_box_rel"
                  dangerouslySetInnerHTML={{ __html: t("transfers.valyutaConfirmMessage")}}
                />
              </div>
              )
            }
            {props.anipay &&
              modalData.note && (
                <div id={'info'} style={{ maxWidth: "fit-content", flexDirection: "column", textAlign: "left", padding: '50px' }} className="flex tab_info_box ">
                  <span
                    style={{ flexDirection: "column" }}
                    className="passive_text_box passive_text_box_rel"
                    dangerouslySetInnerHTML={{ __html: modalData.note }}
                  />
                </div>
              )}

            {props.anipay && modalData.alertText && (
              <div className="flex tab_info_box tab_alert_box">
                <span
                  className="passive_text_box passive_text_box_rel"
                  dangerouslySetInnerHTML={{ __html: modalData.alertText }}
                />
              </div>
            )}
            {errorService && props.anipay && (
              <div className="flex tab_info_box tab_alert_box">
                <span
                  className="passive_text_box passive_text_box_rel"
                  dangerouslySetInnerHTML={{ __html: errorService }}
                />
              </div>
            )}

            {props.transferData && (
              <><h4 className="table-title">{props.tableTitle}</h4>
                <TableComponent
                  columns={props.columnsData}
                  className={`transfer-table salary-table transfers-table__component  modal-table`}
                  data={props.transferSp === true ? props.tableData['TRANSACTION_EMPLIST'] : props.tableData}
                  scroll={{ x: 0 }}
                  pagination={false}
                  rowSelection={false} /></>
            )
            }
            {props.innerData && (
              <>
                <h4 className="table-title">{t("transfers.notes")}</h4>
                <TableComponent
                  columns={props.innerColumnsdata}
                  className="transfer-table salary-table  modal-table transfers-table__component modal_history_table next_modal_responsive"
                  data={props.innerrtableData}
                  scroll={{ x: 0 }}
                  pagination={false}
                  rowSelection={false}
                />
              </>
            )}
            {props.transferSp === true && (
              <>
                <Collapse
                  style={{ marginTop: 40 }}
                  accordion
                  expandIconPosition={'end'}
                  className={'transfersCollapse collapseHistory'}
                  ghost
                  expandIcon={() => (
                    <div className={'creditCollapse__iconBox'}>
                      {activePanel ? <MinusSmallIco /> : <PlusSmallIco />}
                    </div>
                  )}
                  defaultActiveKey={activePanel ? "1" : "0"}
                  onChange={onClosePanel}
                >
                  {/*<div>*/}
                  <Panel
                    className={'creditListPanel'}
                    header={t("transfers.transferHistory")}
                    key="1"
                    extra={<div className={'line'} />}
                  >
                    <TableComponent
                      columns={props.columnsDataTransfer}
                      // className="transfer-table salary-table  modal-table transfers-table__component home_account_opt_table "
                      className="transfer-table salary-table  modal-table transfers-table__component modal_history_table next_modal_responsive"
                      // className="transfers-table__component home_account_opt_table transfer-table-only"
                      data={props.historyList}
                      scroll={{ x: 0 }}
                      pagination={false}
                      rowSelection={false}
                    />
                  </Panel>
                </Collapse>

                <Collapse
                  accordion
                  expandIconPosition={'end'}
                  className={'transfersCollapse'}
                  ghost
                  expandIcon={() => (
                    <div className={'creditCollapse__iconBox'}>
                      {activePanelNotify ? <MinusSmallIco /> : <PlusSmallIco />}
                    </div>
                  )}
                  onChange={onClosePanelNotify}
                  defaultActiveKey={activePanelNotify ? "1" : "0"}
                >
                  {/*<div>*/}
                  <Panel
                    className={'creditListPanel'}
                    header={t("transfers.notes")}
                    key="1"
                    extra={<div className={'line'} />}
                  >
                    {/* <h4 className="table-title">{t("transfers.notes")}</h4> */}
                    <TableComponent
                      columns={props.innerColumnsdata}
                      className="transfer-table salary-table  modal-table transfers-table__component modal_history_table next_modal_responsive"
                      data={props.innerrtableData}
                      scroll={{ x: 0 }}
                      pagination={false}
                      rowSelection={false}
                    />
                  </Panel>
                </Collapse>
              </>
            )}
          </Scrollbar>
        </Modal>
      )}

      {asanModalVisible && (
        <Modal
          title={`ASAN IMZA`}
          closable={false}
          // closeIcon={<ModalCloseIco />}
          centered
          visible={asanModalVisible}
          // onOk={onClose}
          // onCancel={onClose}
          width={422}
          // bodyStyle={{height: 700}}
          className={`manage_faster_menus swift_modal form_next_modal `}
          keyboard={false}
          focusTriggerAfterClose={false}
          footer={false}
        >
          <div className={'flex direction_column asan_sign_popup'}>
            <ul className="office-card__list">
              <li>
                <img src={asanLogo} alt="asan-logo" />
              </li>
              <li>
                <Tooltip
                  id="verificationTooltip"
                  title={text}
                  placement="topRight"
                >
                  <img src={questionMark} alt="question-mark" />
                </Tooltip>
              </li>
            </ul>

            <p>{t(LOGIN_PAGE.MESSAGE)}</p>
            <div className="office-card__statistics mt-15 mb-15">
              {t("modal.controlCode")}
              <span>{verifyCode}</span>
            </div>
            <div className="countdown">
              <CountdownCircleTimer
                isPlaying
                duration={120}
                size={80}
                strokeWidth={3}
                colors={[['#015cd1']]}
                onComplete={resetFormTimer}
              >
                {renderTime}
              </CountdownCircleTimer>
            </div>
          </div>
        </Modal>
      )}

      {simaModalVisible && !simaSignError && (
        <Modal
          title={t("sima.signVia")}
          closable={false}
          centered
          visible={simaModalVisible && !simaSignError}
          width={460}
          className="manage_faster_menus swift_modal"
          bodyStyle={{ padding: '16px 24px 20px', height: 600, overflowY: 'auto' }}
          keyboard={false}
          focusTriggerAfterClose={false}
          footer={false}
        >
          <div className="sima-card" style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>

            {/* <p className="sima-card__subtitle" style={{ marginBottom: 10 }}>
              SİMA mobil tətbiqinə daxil olub QR-kodu skan edin.
            </p> */}

            {simaExpired ? (
              <div className="sima-card__qr sima-card__qr--activate">
                <QRCodeSVG
                  className="sima-card__qr-placeholder"
                  value={simaQrCode || SIMA_QR_PLACEHOLDER}
                  size={200}
                  level="H"
                  includeMargin={true}
                />
                <Button
                  className="sima-card__activate-btn"
                  onClick={retrySimaSign}
                  style={{
                  width:"40%"
                }}
                >
                  {t("sima.activateQr")}
                </Button>
              </div>
            ) : simaQrCode ? (
              <div className="sima-card__qr">
                {/* SİMA payload is ~930 chars; level "H" can't encode that much data,
                    and at 200px the modules are too small to scan. "L" + 260px fits and
                    keeps the code readable by a phone camera. */}
                <QRCodeSVG value={simaQrCode} size={260} level="L" includeMargin={true} />
              </div>
            ) : (
              <div className="sima-card__qr sima-card__qr--loader">
                <Spin size="large" />
              </div>
            )}

            {simaExpired && (
              <p className="sima-card__expired-label">{t("sima.qrExpired")}</p>
            )}

            <p className="sima-card__expire-label">{t("sima.qrExpiryTime")}</p>
            <div className="sima-card__timer-wrap">
              <span className={`sima-card__timer-badge${simaExpired ? ' sima-card__timer-badge--expired' : ''}`}>
                {formatSimaTime(simaExpired ? 0 : simaTimeLeft)}
              </span>
            </div>

            <ol className="sima-card__steps" style={{ width: 'fit-content', margin: '16px auto 0', paddingLeft: 0 }}>
              <li><span>1</span>{t("sima.step1")}</li>
              <li><span>2</span>{t("sima.step2")}</li>
              <li><span>3</span>{t("sima.step3Sign")}</li>
            </ol>
            <p style={{ width: 325, textAlign: 'center', fontSize: 14, fontWeight: 400, color: '#223142', margin: '15.5px auto 0', lineHeight: 'normal' }}>
              {t("sima.errorHelp")}
            </p>

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 15 }}>
              <Button
                size="large"
                onClick={() => {
                  setSimaModalVisible(false)
                  setLoading(false)
                  setLoadingApprove(false)
                }}
                style={{
                width: 141,
                height: 48,
                padding: '13px 20px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 20,
                borderRadius: 10,
                border: '1px solid #015CD1',
                background: '#fff',
                color: '#015CD1',
                fontWeight: 500,
              }}
              >
                {t("sima.back")}
              </Button>
            </div>
          </div>
        </Modal>
      )}

      {simaModalVisible && simaSignError && (
        <Modal
          title={t("common.attention")}
          closeIcon={<span className="sima-error__close">×</span>}
          centered
          visible={simaModalVisible && simaSignError}
          width={580}
          className="manage_faster_menus swift_modal sima_error_modal"
          keyboard={false}
          focusTriggerAfterClose={false}
          footer={false}
          onCancel={() => {
            setSimaModalVisible(false)
            setLoading(false)
            setLoadingApprove(false)
          }}
        >
          <div className="sima-error">
            <div className="sima-error__content">
              {signErrorIcon ? (
                <div className="sima-limit__icon">
                  <span>{signErrorIcon}</span>
                </div>
              ) : (
                <div className="sima-error__icon">
                  <span>✕</span>
                </div>
              )}

              <div className="sima-error__message">
                <p className="sima-error__title">
                  Xəta baş verdi!
                </p>

                <p className="sima-error__text">
                  {simaSignErrorMsg
                    ? simaSignErrorMsg.replace(', ona görə', ', ona görə\n')
                    : 'Zəhmət olmasa, yenidən cəhd edin.'}
                </p>
              </div>
            </div>

            <div className="sima-error__footer">
              <Button
                type="primary"
                onClick={() => {
                  setSimaModalVisible(false)
                  setLoading(false)
                  setLoadingApprove(false)
                }}
              >
                {t("common.close")}
              </Button>
            </div>
          </div>
        </Modal>
      )}

      {otpCodeModalVisible && (
        <Modal
          title={channel == 'OTP' ? t("transfers.signingBySMSCode") : t("transfers.signWithGoogleCode")}
          closeIcon={<ModalCloseIco />}
          centered
          visible={otpCodeModalVisible}
          onOk={hideOtpCodeModal}
          onCancel={hideOtpCodeModal}
          width={props.width || 422}
          className={`manage_faster_menus swift_modal form_next_modal otp_code_verify_modal `}
          keyboard={false}
          focusTriggerAfterClose={false}
          footer={false}
          maskClosable={false}
        >
          <div
            className={
              'flex direction_column align_center otp_code_verify_modal_body'
            }
          >

            {channel == 'OTP' ?
              <p>
                {t("settings.otpcode1")}{phoneNumber} {t("settings.otpcode2")} <br />
                {t("settings.otpcode3")}
              </p>
              : <p>{t("settings.generatedCode")}</p>
            }
            <Form
              form={form}
              onSubmit={(e: any) => e.preventDefault()}
              onFinish={checkOTPCode}
              shouldAutoFocus={true}
              autoComplete="off"
              className={
                otpCodeHasError
                  ? 'message-input-form flex direction_column justify_center has_error'
                  : 'flex direction_column justify_center message-input-form'
              }
            >
              <OtpInput
                value={otpCode}
                onChange={handleValue}
                numInputs={otpNumberCount}
                inputStyle="otpInput"
                isInputNum={true}
                shouldAutoFocus={true}
                className="message-input-form__input"
              />

              {otpCodeHasError && (
                <span className={'verify_code_error flex full justify_center'}>
                  {t("transfers.wrongCodeEntered")}
                </span>
              )}

              <div className={'full flex direction_column'}>
                <ul
                  className="message-form__details full"
                  style={{ marginTop: otpCodeHasError ? 16 : 21 }}
                >
                  <li className="message-form__time">
                    <Timer timerEnd={resetFormTimer} reset={reset} />
                  </li>
                  <li>
                    {channel == 'OTP' &&
                      <a onClick={reSend} className={(smsClicked) ? 'active' : 'disabled'}>{t("modal.detailsData")}</a>
                    }
                  </li>
                </ul>

                {/*<Button*/}
                {/*  type={'ghost'}*/}
                {/*  className={'transparent resend_verify_code_btn' + smsClicked ? 'active' : 'disabled'}*/}
                {/*  onClick={reSend}*/}
                {/*>*/}
                {/*  SMS kodu yenidən göndər*/}
                {/*</Button>*/}

                <div className="login-form__buttons flex justify_center">
                  <Button
                    size={'large'}
                    className="prev ant-btn ant-btn-lg light-button refresh_btn btn flex align_center justify_center "
                    onClick={hideOtpCodeModal}
                  >
                    {t("transfers.back")}
                  </Button>
                  <Button
                    size={'large'}
                    className="next ant-btn ant-btn-lg blue-button next_btn btn flex align_center justify_center"
                    htmlType="submit"
                    loading={loadingSend}
                    
                  >
                    {t("login.confirm")}
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </Modal>
      )}

      {showSuccessOrError && (
        <SuccessOrErrorModal
          visible={showSuccessOrError}
          modalType={popupType}
          modalTitle={popupType === 'success' ? t("home.transfer") : t("notification.attention")}
          modalText={modalText}
          errorIcon={signErrorIcon}
          onClose={() => { onCloseSuccessModal(); onClose() }}
        />
      )}

      {showTimeError && (
        <SuccessOrErrorModal
          visible={showTimeError}
          modalType={'error'}
          modalTitle={t("notification.attention")}
          modalText={t("notification.errorOccured")}
          errorIcon={signErrorIcon}
          onClose={() => { setShowTimeError(false); }}
          onCancel={() => { setShowTimeError(false); setNextModalVisible(true) }}
        />
      )}
      <DgkFormModal
            visible = {openDgkFormModal}
            setVisible = {setOpenDgkFormModal}
            onClose={() => setOpenDgkFormModal(false)}
            />
      <SaveAsTemplate
        visible={saveAsTemplatePopupVisible}
        onClose={setSaveAsTemplatePopupVisible}
        trnType={modalData?.modalTitle !== undefined ? modalData?.modalTitle : ""}
        currentForm={props.currentForm}
        tableData={props.tableData}
      />

    </>
  )
}
const mapDispatchToProps = {
  changeStatusHandler,
  getMessageLists
}
const mapStateToProps = (state: any) => ({

  messageList: state.home.messageList
})

export default connect(mapStateToProps, mapDispatchToProps)(NextModal)
